/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsSubUserDetail,
    MelcoModelsSubUserDetailFromJSON,
    MelcoModelsSubUserDetailFromJSONTyped,
    MelcoModelsSubUserDetailToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsSubUserDetail
 */
export interface MelcoModelsGenericList1MelcoModelsSubUserDetail {
    /**
     * 
     * @type {Array<MelcoModelsSubUserDetail>}
     * @memberof MelcoModelsGenericList1MelcoModelsSubUserDetail
     */
    list: Array<MelcoModelsSubUserDetail>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsSubUserDetail
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsSubUserDetail
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsSubUserDetailFromJSON(json: any): MelcoModelsGenericList1MelcoModelsSubUserDetail {
    return MelcoModelsGenericList1MelcoModelsSubUserDetailFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsSubUserDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsSubUserDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsSubUserDetailFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsSubUserDetailToJSON(value?: MelcoModelsGenericList1MelcoModelsSubUserDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsSubUserDetailToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


